import { useState, } from "react";
import { createModel } from "hox";
import { externalBillService } from "../../externalBillService"
import {
    IDetailsList,
    IExternalBillField,
} from "../../externalBillType"
import { momentFormat } from "@/utils/utils";
export const useExternalBillDetailsModel = createModel(function () {
    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IExternalBillField>({})
    //查看详情列表
    const [detailLookList, setDetailLookList] = useState<IDetailsList[]>([])
    const getDetailLookOne = async (id: string, pattern: string) => {
        let { retData } = await externalBillService.one(id);
        const { vrmExternalSends, ...from } = retData
        setDetailLookForm({
            ...from,
            createTime: momentFormat(from.createTime),
            isTransport: (from.status == 'external_repair.send' || from.status == 'external_repair.init') ? '' : from.isTransport === 0 ? "是" : "否",
            oldPartConfirm: (from.status == 'external_repair.send' || from.status == 'external_repair.init') ? '' : from.oldPartConfirm === 0 ? "是" : "否",
            backTime: momentFormat(from.backTime),
            checkTime: momentFormat(from.checkTime),
        });
        setDetailLookList(vrmExternalSends as IDetailsList[])
    }
    return {
        detailLookForm,
        detailLookList,
        setDetailLookForm,
        setDetailLookList,
        getDetailLookOne
    }
})